





































import { FForm, FMessageBox } from '@fkui/vue';
import BtSambo from '@/components/BtSambo.vue';
import BtBarnInneboende from '@/components/BtBarnInneboende.vue';
import BtBostadstyp from '@/components/BtBostadstyp.vue';
import BtMinaInkomster from '@/components/BtMinaInkomster.vue';
import BtTillgangarSkulder from '@/components/BtTillgangarSkulder.vue';
import BtResultat from '@/components/BtResultat.vue';
import {
    BstPreliminarberakningRestControllerApi,
    Configuration,
    BstPreliminarberakningBodyVO,
    HousingDataBodyVO,
    CustomerBodyVO,
} from 'api-fr-bostadstillgg-preliminrberkning/dist/typescript-axios';
import {
    HousingDataBodyVOGiftEnum,
    HousingDataBodyVOBostadstypEnum,
    HousingDataBodyVOIngarHushallselEnum,
} from 'api-fr-bostadstillgg-preliminrberkning/dist/typescript-axios/api';
import { EventBus } from '@/services/MainService/event-bus';
import Vue from 'vue';
import axios, { AxiosRequestConfig } from 'axios';
import VueAxios from 'vue-axios';
import DataArrayItem from '@/components/DataArrayItem';

Vue.use(VueAxios, axios);

export default Vue.extend({
    name: 'Main',
    components: {
        BtSambo,
        BtBarnInneboende,
        BtBostadstyp,
        BtMinaInkomster,
        BtTillgangarSkulder,
        BtResultat,
        FForm,
        FMessageBox,
    },
    data: () => ({
        focusElement: {} as HTMLHtmlElement,
        isSambo: false,
        btVisaResultat: false,
        btResultatTouched: false,
        dataArray: [] as string[],
        dataArraySambo: [] as DataArrayItem[],
        dataArrayBarnInneboende: [] as DataArrayItem[],
        dataArrayBostadstyp: [] as DataArrayItem[],
        dataArrayInkomster: {
            ensam: [],
            sambo: [],
        },
        dataArrayTillgangarSkulder: {
            ensam: [],
            sambo: [],
        },
        manadsbelopp1: -1 as number,
        manadsbelopp2: -1 as number,
        viewErrorMessage: false,
        isKund2sa: false,
        dataJSON: {
            bostadsuppgifter: {
                gift: HousingDataBodyVOGiftEnum.N as HousingDataBodyVOGiftEnum,
                bostadstyp: HousingDataBodyVOBostadstypEnum.Sma9 as HousingDataBodyVOBostadstypEnum,
                ingarHushallsel: HousingDataBodyVOIngarHushallselEnum.N as HousingDataBodyVOIngarHushallselEnum,
                skuldranta: 0,
                fastighetsskatt: 0,
                antalBarnUnder20: 0,
                antalBarnOver20: 0,
                antalForaldrar: 0,
                antalSyskonUnder20: 0,
                antalSyskonOver20: 0,
                bostadsyta: 0,
                manadshyra: 0,
                tomtrattsavgald: 0,
            },
            kund1: {
                vSokandesAlder: 0,
                sabelopp: 0,
                vArbetsinkomst: 0,
                vAndraInkomster: 0,
                vKapitalInkomst: 0,
                vAnnanFastighet: 0,
                konto: 0,
                vardepapper: 0,
                ovrigaTillgangar: 0,
                vSkulder: 0,
            },
            kund2: {
                vSokandesAlder: 0,
                vArbetsinkomst: 0,
                vAndraInkomster: 0,
                vKapitalInkomst: 0,
                konto: 0,
                vardepapper: 0,
                ovrigaTillgangar: 0,
                vSkulder: 0,
            },
        },
    }),
    mounted() {
        EventBus.$on('sambo-radio', (selection: boolean) => {
            this.isSambo = !selection;
        });
        this.addEventForFocus();
    },
    methods: {
        addEventForFocus() {
            document.addEventListener('keyup', (key) => {
                if (key.key === 'Tab' || key.key === 'Enter' || key.code === 'Space') {
                    setTimeout(() => {
                        this.focusElement = document.activeElement as HTMLHtmlElement;
                        if (this.focusElement.getAttribute('tabindex') === '-1' && this.focusElement.className === 'form-step__header') {
                            this.setFocus();
                        } else {
                            this.focusElement = {} as HTMLHtmlElement;
                        }
                    }, 10);
                }
            });
            document.addEventListener('keydown', (key) => {
                if (key.key === 'Tab') {
                    this.clearFocusElement();
                }
            });
            document.addEventListener('click', () => {
                const element = document.activeElement as HTMLHtmlElement;
                if (element.getAttribute('tabindex') !== '-1' && element.className !== 'form-step__header') {
                    this.clearFocusElement();
                }
            });
        },
        setFocus() {
            if (window.getComputedStyle(this.focusElement, null).boxShadow === 'none') {
                this.focusElement.style.boxShadow = 'var(--f-focus-box-shadow)';
            }
        },
        clearFocusElement() {
            if (this.focusElement && this.focusElement.style) {
                this.focusElement.style.boxShadow = 'none';
                this.focusElement = {} as HTMLHtmlElement;
            }
        },
        getIndexByItemId(dataArray: DataArrayItem[], typeId: string): number {
            let indexOf = -1;
            dataArray.filter(function (ele, i) {
                if (ele.itemId === typeId) {
                    indexOf = i;
                    return;
                }
            });
            return indexOf;
        },

        // ---------- 1. Om Dig
        completeBtSambo(dataArray: DataArrayItem[]): void {
            this.clearBtSamboJSON();

            if (dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omdig.etikett.sambopartner')]) {
                this.dataJSON.bostadsuppgifter.gift =
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omdig.etikett.sambopartner')].value ===
                    this.$t('btp.preliminar.berakning.omdig.etikett.sambopartner.ensamboende')
                        ? HousingDataBodyVOGiftEnum.N
                        : HousingDataBodyVOGiftEnum.J;

                this.dataJSON.kund1.vSokandesAlder = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omdig.etikett.dinalder')].value,
                    10,
                );

                this.dataJSON.kund2.vSokandesAlder = dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omdig.etikett.samboalder')]
                    ? parseInt(dataArray[2].value, 10)
                    : 0;
            }

            this.dataArraySambo = dataArray;
        },
        clearBtSamboJSON(): void {
            this.dataJSON.bostadsuppgifter.gift = HousingDataBodyVOGiftEnum.N;
            this.dataJSON.kund1.vSokandesAlder = 0;
            this.dataJSON.kund2.vSokandesAlder = 0;
        },

        // ---------- 2. Vilka bor hos dig?
        completeBtBarnInneboende(dataArray: DataArrayItem[]): void {
            this.clearBtBarnInneboendeJSON();
            if (
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.ensamboende')] &&
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.hardubarnsomborhosdig.ensamboende')]
                    .value === 'Ja'
            ) {
                this.dataJSON.bostadsuppgifter.antalBarnUnder20 = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.antalbarnunder20ar')].value,
                    10,
                );
                this.dataJSON.bostadsuppgifter.antalBarnOver20 = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.antalbarnover20ar')].value,
                    10,
                );
            }

            if (
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon')] &&
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.delarmedforaldrarsyskon')].value === 'Ja'
            ) {
                this.dataJSON.bostadsuppgifter.antalForaldrar = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.antalforaldrar')].value,
                    10,
                );
                this.dataJSON.bostadsuppgifter.antalSyskonUnder20 = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.antalsyskonunder20')].value,
                    10,
                );
                this.dataJSON.bostadsuppgifter.antalSyskonOver20 = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.omhushallet.etikett.antalsyskonover20')].value,
                    10,
                );
            }

            this.dataArrayBarnInneboende = dataArray;
        },
        clearBtBarnInneboendeJSON(): void {
            this.dataJSON.bostadsuppgifter.antalBarnUnder20 = 0;
            this.dataJSON.bostadsuppgifter.antalBarnOver20 = 0;
            this.dataJSON.bostadsuppgifter.antalForaldrar = 0;
            this.dataJSON.bostadsuppgifter.antalSyskonUnder20 = 0;
            this.dataJSON.bostadsuppgifter.antalSyskonOver20 = 0;
        },

        // ---------- 3. Bostad
        completeBtBostadstyp(dataArray: DataArrayItem[]): void {
            this.clearBtBostadstypJSON();
            let bostadsTypIndex: number = this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.ensam.typavbostad');
            if (bostadsTypIndex < 0) {
                bostadsTypIndex = this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.sambo.typavbostad');
            }
            if (dataArray[bostadsTypIndex]) {
                this.checkCompletedBostadstyp(dataArray[bostadsTypIndex], dataArray);
                this.dataArrayBostadstyp = dataArray;
            }
        },
        checkCompletedBostadstyp(bostadsTyp: DataArrayItem, dataArray: DataArrayItem[]): void {
            if (bostadsTyp.value === this.$t('btp.preliminar.berakning.ombostaden.etikett.typavbostad.hyresratt')) {
                this.completeBtBostadstypHyresratt(dataArray);
            } else if (bostadsTyp.value === this.$t('btp.preliminar.berakning.ombostaden.etikett.typavbostad.bostadsratt')) {
                this.completeBtBostadstypBostadsratt(dataArray);
            } else if (bostadsTyp.value === this.$t('btp.preliminar.berakning.ombostaden.etikett.typavbostad.hus')) {
                this.completeBtBostadstypHus(dataArray);
            }
        },
        clearBtBostadstypJSON(): void {
            this.dataJSON.bostadsuppgifter.bostadstyp = HousingDataBodyVOBostadstypEnum.Lgh2;
            this.dataJSON.bostadsuppgifter.manadshyra = 0;
            this.dataJSON.bostadsuppgifter.ingarHushallsel = HousingDataBodyVOIngarHushallselEnum.N;
            this.dataJSON.bostadsuppgifter.bostadsyta = 0;
            this.dataJSON.bostadsuppgifter.skuldranta = 0;
            this.dataJSON.bostadsuppgifter.fastighetsskatt = 0;
            this.dataJSON.bostadsuppgifter.tomtrattsavgald = 0;
        },
        completeBtBostadstypHyresratt(dataArray: DataArrayItem[]): void {
            this.dataJSON.bostadsuppgifter.bostadstyp = HousingDataBodyVOBostadstypEnum.Lgh1;
            this.dataJSON.bostadsuppgifter.manadshyra = parseInt(
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.manadskostnad')].value.replace(/\s/g, ''),
                10,
            );

            if (
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.hushallsel')] &&
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.hushallsel')].value === 'Ja'
            ) {
                this.dataJSON.bostadsuppgifter.ingarHushallsel = HousingDataBodyVOIngarHushallselEnum.J;
                this.dataJSON.bostadsuppgifter.bostadsyta = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.boyta')].value.replace(/\s/g, ''),
                    10,
                );
            } else {
                this.dataJSON.bostadsuppgifter.ingarHushallsel = HousingDataBodyVOIngarHushallselEnum.N;
                this.dataJSON.bostadsuppgifter.bostadsyta = 0;
            }
        },
        completeBtBostadstypBostadsratt(dataArray: DataArrayItem[]): void {
            this.dataJSON.bostadsuppgifter.bostadstyp = HousingDataBodyVOBostadstypEnum.Lgh2;
            this.dataJSON.bostadsuppgifter.manadshyra = parseInt(
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.manadskostnad')].value.replace(/\s/g, ''),
                10,
            );
            this.dataJSON.bostadsuppgifter.skuldranta = parseInt(
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.rantekostnad')].value.replace(/\s/g, ''),
                10,
            );
            if (
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.hushallsel')] &&
                dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.hushallsel')].value === 'Ja'
            ) {
                this.dataJSON.bostadsuppgifter.ingarHushallsel = HousingDataBodyVOIngarHushallselEnum.J;
                this.dataJSON.bostadsuppgifter.bostadsyta = parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.boyta')].value.replace(/\s/g, ''),
                    10,
                );
            } else {
                this.dataJSON.bostadsuppgifter.ingarHushallsel = HousingDataBodyVOIngarHushallselEnum.N;
                this.dataJSON.bostadsuppgifter.bostadsyta = 0;
            }
        },
        completeBtBostadstypHus(dataArray: DataArrayItem[]): void {
            this.dataJSON.bostadsuppgifter.bostadstyp = HousingDataBodyVOBostadstypEnum.Sma9;
            this.dataJSON.bostadsuppgifter.fastighetsskatt =
                parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.fastighetsavgift')].value.replace(
                        /\s/g,
                        '',
                    ),
                    10,
                ) || 0;
            this.dataJSON.bostadsuppgifter.bostadsyta =
                parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.boyta')].value.replace(/\s/g, ''),
                    10,
                ) || 0;
            this.dataJSON.bostadsuppgifter.skuldranta =
                parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.rantekostnad')].value.replace(/\s/g, ''),
                    10,
                ) || 0;
            this.dataJSON.bostadsuppgifter.tomtrattsavgald =
                parseInt(
                    dataArray[this.getIndexByItemId(dataArray, 'btp.preliminar.berakning.ombostaden.etikett.tomtrattsavgald')].value.replace(
                        /\s/g,
                        '',
                    ),
                    10,
                ) || 0;
        },

        // ---------- 4. Dina inkomster
        // eslint-disable-next-line complexity, @typescript-eslint/no-explicit-any
        completeBtInkomster(dataArray: any): void {
            this.clearBtInkomsterJSON();
            for (let i = 0; i < dataArray.ensam.length; i++) {
                if (dataArray.ensam[i].type === 'sjukelleraktivitetsersattningEnsam') {
                    this.dataJSON.kund1.sabelopp = parseInt(dataArray.ensam[i].value.replace(' ', ''), 10) * 12;
                } else if (dataArray.ensam[i].type === 'anstallningellernaringsverksamhetEnsam') {
                    this.dataJSON.kund1.vArbetsinkomst = parseInt(dataArray.ensam[i].value.replace(' ', ''), 10) * 12;
                } else if (dataArray.ensam[i].type === 'andrainkomsterEnsam') {
                    this.dataJSON.kund1.vAndraInkomster = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10) * 12;
                } else if (dataArray.ensam[i].type === 'kapitalEnsam') {
                    this.dataJSON.kund1.vKapitalInkomst = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10);
                }
            }
            for (let i = 0; i < dataArray.sambo.length; i++) {
                if (dataArray.sambo[i].type === 'sjukelleraktivitetsersattningSambo') {
                    if (dataArray.sambo[i].value) {
                        this.$set(this.dataJSON.kund2, 'sabelopp', parseInt(dataArray.sambo[i].value.replace(' ', ''), 10) * 12);
                        this.isKund2sa = true;
                    } else {
                        Vue.delete(this.dataJSON.kund2, 'sabelopp');
                        this.isKund2sa = false;
                    }
                } else if (dataArray.sambo[i].type === 'anstallningellernaringsverksamhetSambo') {
                    this.dataJSON.kund2.vArbetsinkomst = parseInt(dataArray.sambo[i].value.replace(' ', ''), 10) * 12;
                } else if (dataArray.sambo[i].type === 'andrainkomsterSambo') {
                    this.dataJSON.kund2.vAndraInkomster = parseInt(dataArray.sambo[i].value.replace(/\s/g, ''), 10) * 12;
                } else if (dataArray.sambo[i].type === 'kapitalSambo') {
                    this.dataJSON.kund2.vKapitalInkomst = parseInt(dataArray.sambo[i].value.replace(/\s/g, ''), 10);
                }
            }
            this.dataArrayInkomster = dataArray;
        },
        clearBtInkomsterJSON(): void {
            this.dataJSON.kund1.sabelopp = 0;
            this.dataJSON.kund1.vArbetsinkomst = 0;
            this.dataJSON.kund1.vAndraInkomster = 0;
            this.dataJSON.kund1.vKapitalInkomst = 0;
            this.dataJSON.kund2.vArbetsinkomst = 0;
            this.dataJSON.kund2.vAndraInkomster = 0;
            this.dataJSON.kund2.vKapitalInkomst = 0;
        },

        // ---------- 5. Tillgångar och skulder
        // eslint-disable-next-line complexity, @typescript-eslint/no-explicit-any
        completeBtTillgangarSkulder(dataArray: any): void {
            this.clearBtTillgangarSkulder();
            for (let i = 0; i < dataArray.ensam.length; i++) {
                if (dataArray.ensam[i].itemId === 'taxeringsvarde' && dataArray.ensam[i].value) {
                    this.dataJSON.kund1.vAnnanFastighet = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10);
                } else if (dataArray.ensam[i].itemId === 'kontoEnsamboende' && dataArray.ensam[i].value) {
                    this.dataJSON.kund1.konto = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10) || 0;
                } else if (dataArray.ensam[i].itemId === 'vardepapperEnsamboende' && dataArray.ensam[i].value) {
                    this.dataJSON.kund1.vardepapper = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10) || 0;
                } else if (dataArray.ensam[i].itemId === 'ovrigaTillgangarEnsamboende' && dataArray.ensam[i].value) {
                    this.dataJSON.kund1.ovrigaTillgangar = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10) || 0;
                } else if (dataArray.ensam[i].itemId === 'skulderEnsamboende' && dataArray.ensam[i].value) {
                    this.dataJSON.kund1.vSkulder = parseInt(dataArray.ensam[i].value.replace(/\s/g, ''), 10) || 0;
                }
            }
            for (let i = 0; i < dataArray.sambo.length; i++) {
                if (dataArray.sambo[i].itemId === 'kontoSambo' && dataArray.sambo[i].value) {
                    this.dataJSON.kund2.konto = parseInt(dataArray.sambo[i].value.replace(/\s/g, ''), 10) || 0;
                } else if (dataArray.sambo[i].itemId === 'vardepapperSambo' && dataArray.sambo[i].value) {
                    this.dataJSON.kund2.vardepapper = parseInt(dataArray.sambo[i].value.replace(/\s/g, ''), 10) || 0;
                } else if (dataArray.sambo[i].itemId === 'ovrigaTillgangarSambo' && dataArray.sambo[i].value) {
                    this.dataJSON.kund2.ovrigaTillgangar = parseInt(dataArray.sambo[i].value.replace(/\s/g, ''), 10) || 0;
                } else if (dataArray.sambo[i].itemId === 'skulderSambo' && dataArray.sambo[i].value) {
                    this.dataJSON.kund2.vSkulder = parseInt(dataArray.sambo[i].value.replace(/\s/g, ''), 10) || 0;
                }
            }
            this.dataArrayTillgangarSkulder = dataArray;
        },
        clearBtTillgangarSkulder(): void {
            this.dataJSON.kund1.vAnnanFastighet = 0;
            this.dataJSON.kund1.konto = 0;
            this.dataJSON.kund1.vardepapper = 0;
            this.dataJSON.kund1.ovrigaTillgangar = 0;
            this.dataJSON.kund1.vSkulder = 0;
            this.dataJSON.kund2.konto = 0;
            this.dataJSON.kund2.vardepapper = 0;
            this.dataJSON.kund2.ovrigaTillgangar = 0;
            this.dataJSON.kund2.vSkulder = 0;
        },
        rensaResultat() {
            this.btVisaResultat = false;
        },
        getResponse(): void {
            const config = {
                basePath: '/api/bstpreliminarberakning',
            } as Configuration;

            const api = new BstPreliminarberakningRestControllerApi(config);
            const bostadsuppgifter: HousingDataBodyVO = this.dataJSON.bostadsuppgifter;
            const kund1: CustomerBodyVO = this.dataJSON.kund1;
            const kund2: CustomerBodyVO = this.dataJSON.kund2;
            const options: AxiosRequestConfig = {
                params: {
                    kanal: 1,
                },
            };
            let vo: BstPreliminarberakningBodyVO;
            if (kund2.vSokandesAlder >= 19) {
                vo = {
                    bostadsuppgifter,
                    kund1,
                    kund2,
                };
            } else {
                vo = {
                    bostadsuppgifter,
                    kund1,
                };
            }
            api.publicV1BeraknaPost(vo, options)
                .then((result) => {
                    this.manadsbelopp1 = result && result.data && result.data.manadsbelopp1 ? result.data.manadsbelopp1 : -1;
                    this.manadsbelopp2 = result && result.data && result.data.manadsbelopp2 ? result.data.manadsbelopp2 : -1;
                    this.btVisaResultat = true;
                    this.btResultatTouched = true;
                    this.viewErrorMessage = false;
                    this.$nextTick(() => {
                        const resultatRubrik = this.$el.querySelector('.resultatRubrik') as HTMLElement;
                        if (resultatRubrik) {
                            resultatRubrik.focus();
                        }
                    });
                    /**
                     * Tilfällig lösning för att återställa validering efter submit.
                     * Efter som kund stannar på samma sida efter en beräkning är utförd så visas felvalideringslänkar när ingen container har
                     * valideringsfel när kunden uppdatera information, främst när radio knapp eller checkbox ändras.
                     */
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Object.values((this.$refs['fform'] as any).components).forEach((component: any) => {
                        component.ref.numberOfTimesSubmitted = 0;
                    });
                })
                .catch(() => {
                    this.viewErrorMessage = true;
                });
        },
    },
});
